import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import {
  Stroke,
  Style,
} from "ol/style";

export class CommonFeature {
  constructor({coordinates,
    imgPxWidth,
    imgPxHeight,
    type, 
    payload,
    geometryType, 
    styles}) {
    // this check will check all the required parameters and
    // that they are not false, null, 0 or ""
    if (!imgPxWidth || !imgPxHeight || !type) {
      return null;
    }

    this.type = type;
    this.objectType = 99;

    const createGeometry = (geomType) => {
      let result;
      switch (geomType) {
        case "point":
          this.coordinates = [
            parseFloat(coordinates.kx) * imgPxWidth,
            parseFloat(coordinates.ky) * imgPxHeight,
          ];
          result = new Point(this.coordinates);
          break;
        case "line":
          this.coordinates = coordinates.map((coordObj) => {
            return [
              coordObj.kx * imgPxWidth,
              coordObj.ky * imgPxHeight
            ]
          })
          result = new LineString(this.coordinates);
          break;
        default:
          break;
      }
      return result
    };

    this.openLayersFeature = new Feature({
      type,
      payload,
      geometry: createGeometry(geometryType),
    });

    if(styles){
      const {stroke} = styles;
      const {
        color: strokeColor, 
        width: widthColor
      } = stroke;
      const style = new Style({
        stroke: new Stroke({
          color: strokeColor,
          width: widthColor,
        }),
      })
      this.openLayersFeature.setStyle(style);
    }

    return this.openLayersFeature;
  }

  setStyles(style) {
    this.openLayersFeature.setStyle(style);
  }

  // create circle with text style
}
